/**
 * Cameras / snapshots — contract paths for device panel + Evidence (#/snapshots).
 */

import { buildContractPath } from "./api/contract-client.js";

export const CAMERAS_CONSOLE_TIMEOUT_MS = 45000;
export const CAMERAS_SNAPSHOT_IMAGE_TIMEOUT_MS = 15000;

/** Append ``owner_admin`` for superadmin cross-tenant camera ops. */
export function cameraApiPathWithOwner(path, ownerAdmin) {
  const oa = String(ownerAdmin || "").trim();
  if (!oa) return path;
  const join = path.includes("?") ? "&" : "?";
  return `${path}${join}owner_admin=${encodeURIComponent(oa)}`;
}

/** @param {Record<string, string | number>} [query] */
export function buildGetAdminCameraSnapshotsPath(query) {
  return buildContractPath("get__admin_camera-snapshots", { query });
}

/** @param {string} snapshotId */
export function buildGetAdminCameraSnapshotImagePath(snapshotId) {
  return buildContractPath("get__admin_camera-snapshots_p_image", {
    pathParams: [snapshotId],
  });
}

/** @param {string} snapshotId */
export function buildPostAdminCameraSnapshotSendEmailPath(snapshotId) {
  return buildContractPath("post__admin_camera-snapshots_p_send-email", {
    pathParams: [snapshotId],
  });
}

export function buildGetAdminCamerasPath() {
  return buildContractPath("get__admin_cameras");
}

export function buildPostAdminCamerasPath() {
  return buildContractPath("post__admin_cameras");
}

/** @param {string} cameraId */
export function buildDeleteAdminCamerasPath(cameraId) {
  return buildContractPath("delete__admin_cameras_p", {
    pathParams: [cameraId],
  });
}

export function buildPostAdminCamerasProbeTestPath() {
  return buildContractPath("post__admin_cameras_probe-test");
}

export function buildPostAdminCamerasTestCapturePath() {
  return buildContractPath("post__admin_cameras_test-capture");
}

/** @param {string} deviceId */
export function buildGetAdminDevicesCameraBindingsPath(deviceId) {
  return buildContractPath("get__admin_devices_p_camera-bindings", {
    pathParams: [deviceId],
  });
}

/** @param {string} deviceId */
export function buildPostAdminDevicesCameraBindingsPath(deviceId) {
  return buildContractPath("post__admin_devices_p_camera-bindings", {
    pathParams: [deviceId],
  });
}

/** @param {string} deviceId @param {string} bindingId */
export function buildDeleteAdminDevicesCameraBindingsPath(deviceId, bindingId) {
  return buildContractPath("delete__admin_devices_p_camera-bindings_p", {
    pathParams: [deviceId, bindingId],
  });
}

/** @param {string} deviceId @param {{ since?: string }} [opts] */
export function buildGetAdminDevicesCameraDiscoveryPath(deviceId, opts = {}) {
  const since = String(opts.since || "").trim();
  return buildContractPath("get__admin_devices_p_camera-discovery", {
    pathParams: [deviceId],
    query: since ? { since } : undefined,
  });
}

/** @param {string} deviceId */
export function buildPostAdminDevicesCameraDiscoveryPath(deviceId) {
  return buildContractPath("post__admin_devices_p_camera-discovery", {
    pathParams: [deviceId],
  });
}

/** @deprecated use buildPostAdminDevicesCameraDiscoveryPath */
export function buildPostDeviceCameraDiscoveryPath(deviceId) {
  return buildPostAdminDevicesCameraDiscoveryPath(deviceId);
}

/** @deprecated use buildGetAdminDevicesCameraDiscoveryPath */
export function buildGetDeviceCameraDiscoveryPath(deviceId, opts = {}) {
  return buildGetAdminDevicesCameraDiscoveryPath(deviceId, opts);
}
